import { render } from "./MovieSection.vue?vue&type=template&id=f5f3dc88"
import script from "./MovieSection.vue?vue&type=script&lang=js"
export * from "./MovieSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__